






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AllocationStatus extends Vue {
  @Prop({ default: false })
  public readonly isModified!: boolean;

  @Prop({ default: "Modified" })
  public readonly label!: string;

  @Prop({ default: false })
  public readonly showOnMobile!: boolean;
}
